import { headerAction } from './modules/headerAction';
// import { toggleClass } from './modules/toggleClass';
import { scrollmagic } from './modules/scrollmagic';
import { smooth } from './modules/smooth';
import { lodashAction } from './modules/lodashAction';
import { blobAnimation } from './modules/blob';
import { blob02Animation } from './modules/blob02';
import { slider } from './modules/slider';
blobAnimation();
blob02Animation();
headerAction();
// toggleClass();
scrollmagic();
smooth();
lodashAction();
slider();
